import script from "./VatPurchaseSalesBook.vue?vue&type=script&setup=true&lang=js"
export * from "./VatPurchaseSalesBook.vue?vue&type=script&setup=true&lang=js"

import "./VatPurchaseSalesBook.vue?vue&type=style&index=0&id=cf057758&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf057758"]])

export default __exports__